import { Theme } from "./types";

export const lightTheme: Theme = {
  colors: {
    ui: {
      background: {
        primary: "#000000",
        secondary: "#1A1A1A",
        tertiary: "#333333",
      },
      text: {
        primary: "#FFFFFF",
        secondary: "#CCCCCC",
        disabled: "#999999",
        highlight: "#FFFFFF",
      },
      border: {
        default: "#666666",
        hover: "#CCCCCC",
        focus: "#66B3FF",
        highlight: "#FF00FF",
      },
      bg: {
        primary: "#000000",
        secondary: "#1A1A1A",
        tertiary: "#333333",
        highlight: "#FF00FF", // Purple for testing
      },
    },
    viewport: {
      background: "#FFFFFF",
      grid: "#E6E6E6",
      axis: {
        x: "#FF0000",
        y: "#00FF00",
        z: "#0000FF",
      },
    },
    geometry: {
      lines: {
        default: "#000000",
        selected: "#0066FF",
        highlighted: "#FF3300",
      },
      edges: {
        default: "#000000",
        selected: "#0066FF",
        hidden: "#CCCCCC",
      },
      faces: {
        default: "#F5F5F5",
        selected: "#E6F0FF",
        highlighted: "#FFE6D9",
      },
      points: {
        default: "#000000",
        selected: "#0066FF",
        control: "#FF3300",
      },
    },
    materials: {
      default: {
        diffuse: "#F5F5F5",
        specular: "#FFFFFF",
        ambient: "#E6E6E6",
      },
    },
  },
};

export const darkTheme: Theme = {
  colors: {
    ui: {
      background: {
        primary: "#333333",
        secondary: "#444444",
        tertiary: "#555555",
      },
      text: {
        primary: "#FFFFFF",
        secondary: "#FFFFFF",
        disabled: "#CCCCCC",
        highlight: "#FFFFFF",
      },
      border: {
        default: "#666666",
        hover: "#CCCCCC",
        focus: "#66B3FF",
        highlight: "#FF00FF",
      },
      bg: {
        primary: "#333333",
        secondary: "#444444",
        tertiary: "#555555",
        highlight: "#FF00FF", // Purple for testing
      },
    },
    viewport: {
      background: "#000000",
      grid: "#666666",
      axis: {
        x: "#FF0000",
        y: "#00FF00",
        z: "#0000FF",
      },
    },
    geometry: {
      lines: {
        default: "#FFFFFF",
        selected: "#66B3FF",
        highlighted: "#FF6633",
      },
      edges: {
        default: "#FFFFFF",
        selected: "#66B3FF",
        hidden: "#666666",
      },
      faces: {
        default: "#666666",
        selected: "#999999",
        highlighted: "#CCCCCC",
      },
      points: {
        default: "#FFFFFF",
        selected: "#66B3FF",
        control: "#FF6633",
      },
    },
    materials: {
      default: {
        diffuse: "#666666",
        specular: "#999999",
        ambient: "#333333",
      },
    },
  },
};

// Helper function to determine if a geometry is using theme defaults
export const isUsingThemeDefaults = (appearance: {
  useThemeDefaults: boolean;
}): boolean => {
  return appearance.useThemeDefaults;
};

// Helper function to get the current theme (always dark)
export const getCurrentTheme = (): Theme => {
  return darkTheme;
};
